import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router";
import { i18n } from "./i18n";
import { initTelemetry } from "./services/telemetry";
import { isMobileUserAgent, redirectMobileToApp } from "./services/mobileRedirect";
import "flag-icons/css/flag-icons.min.css";
import "./styles/global.css";

initTelemetry();

if (isMobileUserAgent()) {
  redirectMobileToApp();
} else {
  const app = createApp(App);
  app.use(router);
  app.use(i18n);
  app.mount("#app");
}
